import * as React from "react";
import type { SVGProps } from "react";
const SvgCorendonAirlines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#cf2a2b"
      fillRule="evenodd"
      d="M41.46 12.275c-2.161.062-4.301-.982-4.768-3.239-.281-1.358-.161-2.819.521-4.045.745-1.344 2.49-2.25 3.97-2.447 2.572-.344 4.98 1.358 5.378 4.021.435 2.94-2.299 5.41-5.05 5.71zM9.203 24.825c.308-2.74-1.691-4.004-3.55-4.48-1.623-.396-2.971-.586-2.587-1.857l.058-.131c.594-1.258 2.058-1.92 4.017-2.447l.84-.206c1.853-.428 4.024-.59 6.127-.965a18 18 0 0 0 2.686-.669c1.948-.861 3.203-2.75 3.996-4.669.336-.785.59-1.578.775-2.308.285-1.155.511-2.164.868-2.916.36-.668.85-1.12 1.65-1.233 1.56-.172 2.181 1.533 2.689 4 .576 2.84.494 6.833 1.87 9.28.737.996 2.133 1.354 3.82 1.347 1.993-.007 4.35-.524 6.466-1.15 2.649-.786 4.954-1.5 6.415-1.369.761.07 1.303.369 1.567 1.01.063.172.094.354.09.538-.309 1.54-2.967 3.335-6.377 5.402-4.291 2.595-9.724 4.928-11.934 7.578a3.7 3.7 0 0 0-.696 1.664c-.617 2.605 1.5 6.01 3.914 8.78 2.326 2.64 4.48 4.9 4.39 6.381-.114.33-.343.606-.644.78a2.17 2.17 0 0 1-1.287.31c-1.927-.063-4.792-1.903-7.95-4.232-3.963-2.922-7.695-6.902-10.682-8.129a2.8 2.8 0 0 0-.817-.148c-2.202-.069-4.137 2.584-5.361 5.182-1.118 2.392-1.938 4.463-2.895 4.28a1.13 1.13 0 0 1-.587-.403c-.525-.606-.7-1.654-.651-3.005.068-1.32.35-2.908.727-4.648.72-3.267 2.058-6.823 2.703-9.714a16 16 0 0 0 .35-1.854"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCorendonAirlines;
